export function Card({ children, className = '' }) {
  return <div className={`card ${className}`}>{children}</div>;
}

export function CardTitle({ children }) {
  return <h3 className="text-sm font-medium text-surface-3">{children}</h3>;
}

export function CardValue({ children, className = '' }) {
  return <p className={`text-2xl font-semibold text-surface ${className}`}>{children}</p>;
}

export function StatCard({ label, value, tone = 'brand' }) {
  const toneClass =
    tone === 'brand' ? 'text-brand-300'
    : tone === 'success' ? 'text-success'
    : tone === 'warning' ? 'text-warning'
    : tone === 'info' ? 'text-info'
    : 'text-surface';
  return (
    <div className="card-elevated">
      <div className="text-xs text-surface-4 uppercase tracking-wide">{label}</div>
      <div className={`mt-1 text-2xl font-semibold ${toneClass}`}>{value}</div>
    </div>
  );
}
